import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-num-anno-mese-filter',
  templateUrl: './num-anno-mese-filter.component.html',
  styleUrls: ['./num-anno-mese-filter.component.scss']
})
export class NumAnnoMeseFilterComponent extends FilterAbstractModel implements OnInit, OnDestroy, OnChanges {

  listMonthFilter: any[];
  annoMese: Date;

  @Input() numAnnoMeseData: any;
  @Input() numAnnoMeseSelected: any;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('numAnnoMeseData' in changes) {
      this.listMonthFilter = this.numAnnoMeseData;
      this.optionSelected = this.numAnnoMeseData ? this.numAnnoMeseData[0] : null;
    }
    if (this.numAnnoMeseSelected) {
      this.optionSelected = this.numAnnoMeseSelected;
    }
  }

  getAnnoMese(annoMese: number ): string {
    const year = Number(annoMese.toString().substring(0, 4));
    const month = Number(annoMese.toString().substring(4, 6));

    const options = { month: 'long', year: 'numeric' };
    const parsedYearMonth = new Date(year, month - 1);

    return parsedYearMonth.toLocaleDateString('en-US', options);
  }

  reset() {
    this.optionSelected = this.listMonthFilter ? this.listMonthFilter[0] : null;
  }

  compareObjects(o1: any, o2: any) {
    if (o2 === undefined || o2 ===  null) {
      return false;
    }
    return o1 === o2;
  }


  ngOnDestroy(): void {
  }

}
